<template>
    <div>
        <b-row>
            <b-col sm="12" md="2">
                <b-form-group>
                    <label>Contratações (DE)</label>
                    <date-picker
                        v-model="dataDe"
                        :config="$datePickerOptions2"
                        v-mask="'##/##/####'"
                    ></date-picker>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="2">
                <b-form-group>
                    <label>Contratações (ATÉ)</label>
                    <date-picker
                        v-model="dataAte"
                        :config="$datePickerOptions2"
                        v-mask="'##/##/####'"
                    ></date-picker>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="3">
                <b-form-group>
                    <label>Unidade</label>
                    <b-form-select
                        :plain="true"
                        :options="unidades"
                        text-field="unidade"
                        value-field="codUnidade"
                        v-model="unidade"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="12" v-if="perfil != 'gestor'" md="3">
                <b-form-group>
                    <label>Gestor</label>
                    <b-form-select
                        :plain="true"
                        :options="gestores"
                        text-field="gestor"
                        value-field="codGestor"
                        v-model="gestor"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="2">
                <b-form-group>
                    <label>Situação</label>
                    <b-form-select
                        :plain="true"
                        :options="situacoes"
                        text-field="situacaoDescr"
                        value-field="situacao"
                        v-model="situacao"
                    ></b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    props: {
        servicos: {
            type: Object
        },

        perfil: {
            type: String
        },

        filtros: {
            type: Object
        }
    },

    data() {
        return {
            unidades: [],
            unidade: -1,
            gestores: [],
            gestor: -1,
            situacoes: [],
            situacao: -1,
            dataDe: null,
            dataAte: null,
            filtroInicial: {
                unidade: false,
                gestor: false,
                situacao: false,
                dataDe: true,
                dataAte: true
            }
        }
    },

    methods: {
        obterOpcoesFiltros() {
            this.$store.dispatch('addRequest')
            this.servicos.obterOpcoesFiltros().then((response) => {
                if (response) {
                    if (response.success) {
                        this.unidades = response.data.unidades
                        this.unidades.unshift({
                            codUnidade: -1,
                            unidade: 'TODAS'
                        })
                        if (this.perfil != 'gestor') {
                            this.gestores = response.data.gestores
                            this.gestores.unshift({
                                codGestor: -1,
                                gestor: 'TODOS'
                            })
                        }
                        this.situacoes = response.data.situacoes
                        this.situacoes.unshift({
                            situacao: -1,
                            situacaoDescr: 'TODAS'
                        })
                        this.preencherFormulario()
                    } else {
                        this.$toast.error(
                            'Erro ao obter opções dos filtros',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        preencherFormulario() {
            this.unidade = this.filtros.unidade
            this.gestor = this.filtros.gestor
            this.situacao = this.filtros.situacao
            this.dataDe = this.$moment(this.filtros.dataDe).format('DD/MM/YYYY')
            this.dataAte = this.$moment(this.filtros.dataAte).format(
                'DD/MM/YYYY'
            )
        },

        atualizarFiltros() {
            let filtrosDto = {
                unidade: this.unidade,
                gestor: this.gestor,
                situacao: this.situacao,
                dataDe: this.$moment(this.dataDe, 'DD/MM/YYYY').format(
                    'YYYY-MM-DD'
                ),
                dataAte: this.$moment(this.dataAte, 'DD/MM/YYYY').format(
                    'YYYY-MM-DD'
                )
            }
            this.$emit('atualizarFiltros', filtrosDto)
        }
    },

    mounted() {
        this.obterOpcoesFiltros()
    },

    watch: {
        unidade() {
            if (!this.filtroInicial.unidade) {
                this.atualizarFiltros()
            } else {
                this.filtroInicial.unidade = false
            }
        },
        gestor() {
            if (!this.filtroInicial.gestor) {
                this.atualizarFiltros()
            } else {
                this.filtroInicial.gestor = false
            }
        },
        situacao() {
            if (!this.filtroInicial.situacao) {
                this.atualizarFiltros()
            } else {
                this.filtroInicial.situacao = false
            }
        },
        dataDe() {
            if (!this.filtroInicial.dataDe) {
                this.atualizarFiltros()
            } else {
                this.filtroInicial.dataDe = false
            }
        },
        dataAte() {
            if (!this.filtroInicial.dataAte) {
                this.atualizarFiltros()
            } else {
                this.filtroInicial.dataAte = false
            }
        }
    }
}
</script>
